import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { throwError } from 'rxjs';
import { LocalStorageService } from './localstorage.service';

@Injectable({
    providedIn: 'root'
})
export class SecurityHelper {
    constructor(private jwtHelper: JwtHelperService, private localStorageService: LocalStorageService) {}

    public getToken(): string {
        return this.localStorageService.loadInfo('token');
    }

    public validateToken<T>(token: string): T {
        const obj: T = this.jwtHelper.decodeToken(token);
        if (this.jwtHelper.isTokenExpired(token)) {
            throwError('token.expired');
        }
        return obj;
    }

    public hasOneOfPermissions(permissions: string[]): boolean {
        const userPermission = this.localStorageService.loadInfo('user_permissions');
        if (!userPermission || userPermission === 'undefined') {
            return false;
        }
        const userPermissions = JSON.parse(userPermission);
        if (!permissions || permissions.length === 0) {
            return true;
        }

        if (!userPermissions) {
            return false;
        }
        const filteredArray = userPermissions.filter(
            (p: any) => (p.permissionId && permissions.includes(p.permissionId.toLocaleLowerCase())) || permissions.includes(p)
        );
        return filteredArray && filteredArray.length > 0;
    }

    public getPermissions() {
        const userPermission = this.localStorageService.loadInfo('user_permissions');
        if (!userPermission || userPermission === 'undefined') {
            return [];
        }
        const userPermissions = JSON.parse(userPermission);
        return userPermissions;
    }
}
